module.exports = __webpack_public_path__ + "img/login-sanjose3.11326fd5.svg";